// sessionStorage, not localStorage - deliberately.
//
// `context` (which module the user is in: myBiofuelCircle, Market, Network, Control Tower)
// is the only slice we persist, and it is what decides whether screens like Find Buyers
// reveal counterparty company names. localStorage is shared by every tab on the origin, so
// opening Control Tower in a second tab wrote ctx='5' into storage that the myBiofuelCircle
// tab also read - and on that tab's next rehydrate (a refresh, a re-login, or the logout
// broadcast's reload) it came back up in Control Tower context showing company names.
//
// sessionStorage is per tab, so the context still survives a refresh of the tab that set it
// while tabs no longer leak context into one another.
import storage from 'redux-persist/lib/storage/session';

export default storage;
